import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
export default ((_ref) => {
  let {
    app,
    store
  } = _ref;
  const currentApp = app;
  currentApp.i18n = new VueI18n({
    locale: store.state.i18n.currentLocale.language,
    fallbackLocale: 'fr',
    silentTranslationWarn: process.env.NODE_ENV === 'production'
  });
});